export const currencyCodes: { [key: string]: string } = {
    "USD": "$",
    "AFG": "؋",
    "ALB": "L",
    "DZA": "د.ج",
    "ASM": "$",
    "AND": "€",
    "AGO": "Kz",
    "AIA": "$",
    "ATG": "$",
    "ARG": "$",
    "ARM": "֏",
    "ABW": "ƒ",
    "AUS": "AU$",
    "AUT": "€",
    "AZE": "₼",
    "BHS": "$",
    "BHR": ".د.ب",
    "BGD": "৳",
    "BRB": "$",
    "BLR": "Br",
    "BEL": "€",
    "BLZ": "$",
    "BEN": "CFA",
    "BMU": "$",
    "BTN": "Nu.",
    "BOL": "Bs.",
    "BIH": "КМ",
    "BWA": "P",
    "BRA": "R$",
    "IOT": "$",
    "VGB": "$",
    "BRN": "$",
    "BGR": "лв",
    "BFA": "CFA",
    "BDI": "FBu",
    "KHM": "៛",
    "CMR": "CFA",
    "CAN": "$",
    "CPV": "$",
    "CYM": "$",
    "CAF": "CFA",
    "TCD": "CFA",
    "CHL": "$",
    "CHN": "¥",
    "CXR": " AU$",
    "CCK": "AU$",
    "COL": "$",
    "COM": "CF",
    "COK": "NZ$",
    "CRI": "₡",
    "HRV": "€",
    "CUB": "$",
    "CUW": "ƒ",
    "CYP": "€",
    "CZE": "Kč",
    "COD": "FC",
    "DNK": "kr",
    "DJI": "Fdj",
    "DMA": "$",
    "DOM": "$",
    "TLS": "$",
    "ECU": "$",
    "EGY": "£",
    "SLV": "$",
    "GNQ": "CFA",
    "ERI": "Nkf",
    "EST": "€",
    "ETH": "Br",
    "FLK": "£",
    "FRO": "£",
    "FJI": "$",
    "FIN": "€",
    "FRA": "€",
    "PYF": "₣",
    "GAB": "CFA",
    "GMB": "D",
    "GEO": "₾",
    "DEU": "€",
    "GHA": "₵",
    "GIB": "£",
    "GRC": "€",
    "GRL": "kr.",
    "GRD": "$",
    "GUM": "",
    "GTM": "Q",
    "GGY": "",
    "GIN": "FG",
    "GNB": "CFA",
    "GUY": "$",
    "HTI": "G",
    "HND": "L",
    "HKG": "HK$",
    "HUN": "Ft",
    "ISL": "kr",
    "IND": "₹",
    "IDN": "Rp",
    "IRN": "﷼",
    "IRQ": "ع.د",
    "IRL": "€",
    "IMN": "£",
    "ISR": "₪",
    "ITA": "€",
    "CIV": "F.CFA",
    "JAM": "$",
    "JPN": "¥",
    "JEY": "£",
    "JOR": "د.ا",
    "KAZ": "₸",
    "KEN": "Sh",
    "KIR": "$",
    "XKX": "€",
    "KWT": "د.ك",
    "KGZ": "с",
    "LAO": "₭",
    "LVA": "€",
    "LBN": "ل.ل",
    "LSO": "L",
    "LBR": "$",
    "LBY": "ل.د",
    "LIE": "CHF",
    "LTU": "€",
    "LUX": "€",
    "MAC": "MOP$",
    "MKD": "ден",
    "MDG": "Ar",
    "MWI": "MK",
    "MYS": "RM",
    "MDV": "Rf",
    "MLI": "CFA",
    "MLT": "€",
    "MHL": "$",
    "MRT": "UM",
    "MUS": "₨",
    "MYT": "€",
    "MEX": "$",
    "FSM": "$",
    "MDA": "L",
    "MCO": "€",
    "MNG": "₮",
    "MNE": "€",
    "MSR": "$",
    "MAR": "د.م.",
    "MOZ": "MT",
    "MMR": "K",
    "NAM": "$",
    "NRU": "$",
    "NPL": "₨",
    "NLD": "€",
    "ANT": "€",
    "NCL": "₣",
    "NZL": "$",
    "NIC": "C$",
    "NER": "CFA",
    "NGA": "₦",
    "NIU": "NZ$",
    "PRK": "₩",
    "MNP": "$",
    "NOR": "kr",
    "OMN": "ر.ع.",
    "PAK": "₨",
    "PLW": "$",
    "PSE": "₪",
    "PAN": "B/.",
    "PNG": "K",
    "PRY": "₲",
    "PER": "S/",
    "PHL": "₱",
    "PCN": "NZ$",
    "PRI": "$",
    "POL": "zł",
    "PRT": "€",
    "QAT": "ر.ق",
    "COG": "CFA",
    "REU": "€",
    "ROU": "lei",
    "RUS": "₽",
    "RWA": "FRw",
    "BLM": "€",
    "SHN": "£",
    "KNA": "$",
    "LCA": "$",
    "MAF": "€",
    "SPM": "€",
    "VCT": "$",
    "WSM": "T",
    "SMR": "€",
    "STP": "Db",
    "SAU": "ر.س",
    "SEN": "CFA",
    "SRB": "дин",
    "SYC": "₨",
    "SLE": "Le",
    "SGP": "$",
    "SXM": "Cg.",
    "SVK": "€",
    "SVN": "€",
    "SLB": "$",
    "SOM": "Sh",
    "ZAF": "R",
    "KOR": "₩",
    "SSD": "£",
    "ESP": "€",
    "LKA": "Rs",
    "SDN": "£",
    "SUR": "$",
    "SJM": "Øre",
    "SWZ": "L",
    "SWE": "kr",
    "CHE": "CHF",
    "SYR": "£",
    "TWN": "NT$",
    "TJK": "ЅМ",
    "TZA": "Sh",
    "THA": "฿",
    "TGO": "CFA",
    "TKL": "$",
    "TON": "T$",
    "TTO": "$",
    "TUN": "د.ت",
    "TUR": "₺",
    "TKM": "m",
    "TCA": "$",
    "TUV": "$",
    "VIR": "$",
    "UGA": "Sh",
    "UKR": "₴",
    "ARE": "د.إ",
    "GBR": "£",
    "USA": "$",
    "URY": "$",
    "UZB": "so'm",
    "VUT": "VT",
    "VAT": "€",
    "VEN": "Bs.",
    "VNM": "₫",
    "WLF": "F",
    "ESH": "د. م",
    "YEM": "﷼",
    "ZMB": "ZK",
    "ZWE": "$"
}